'use client'

import { useEffect } from 'react'
import { Analytics } from '@vercel/analytics/next'

export default function ConsentAwareAnalytics() {
  useEffect(() => {
    // Listen for consent updates from the banner
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('consent', 'update', {
          'analytics_storage': detail.analytics ? 'granted' : 'denied',
          'ad_storage': detail.marketing ? 'granted' : 'denied',
          'ad_user_data': detail.marketing ? 'granted' : 'denied',
          'ad_personalization': detail.marketing ? 'granted' : 'denied'
        })
      }
    }
    window.addEventListener('cookie-consent-update', handler)
    return () => window.removeEventListener('cookie-consent-update', handler)
  }, [])

  return <Analytics />
}


